import { useEffect, useRef, useState } from 'react';
import { ProTableOt, Toaster, toast, Row, Col, Button, useProTableOt, Form, Modal, message, Select } from '../../ui/ot'
import { useBorrower } from '../controllers/BorrowerController';
import { useCheckoutHistory } from '../controllers/CheckoutHistoryController';
import dayjs from 'dayjs'
import { Link } from 'react-router-dom';
import { useCheckin } from '../controllers/CheckinController';
import { useCheckout } from '../controllers/CheckoutController';
import { useLibrary } from "../controllers/LibraryController";
import { useTranslation } from 'react-i18next';
import RenewSettingModal, { RenewSettingForm } from './RenewSettingModal';


const RenewSettingProTableOt = ({
    keyPrefix = "library.backstage.Circulation.RenewSetting.borrowed_list",
    borrowernumber: borrowernumber,
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    // propsRowKey = "item_itemnumber",
    propsRowKey = "key",
    propsForm,
    customColumns = [],
    customFormItems = () => { },
    extraActionRender = () => { },
    toolBarRender = (tools) => ([...tools]),
    propsUseCheckoutHistory = useCheckoutHistory,
    propsUseCheckout = useCheckout,
    propsOnFinish = () => { },
    propsOnBefore = () => { },
    onSelectChange = () => { },
    fieldName,
    hasValue = false,
    permission_level = null, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const actionRef = useRef()
    const [extra_columns, set_extra_columns] = useState([]);
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [form_] = Form.useForm();
    const form = propsForm ?? form_;
    const [axiosMode, setAxiosMode] = useState("get")
    const columns = [
        {
            title: t("issue_id"),
            dataIndex: 'issue_id',
            key: 'issue_id',
        },
        {
            title: t("issue_borrowernumber"),
            dataIndex: 'issue_borrowernumber',
            key: 'issue_borrowernumber',
        },
        {
            title: t("issue_borrowername"),
            dataIndex: 'staff_name',
            key: 'staff_name',
            render: (text, record) => {
                return <>
                <Row>
                    <Col span={24}>{record?.staff_name}</Col>
                    <Col span={24}>{record?.staff_english_name}</Col>
                </Row>
                </>
            }
        },
        {
            title: t("due_date"),
            dataIndex: 'issue_date_due',
            key: 'issue_date_due',
            render: (text) => {
                return <>{dayjs(text).format('YYYY-MM-DD')}</>
            }
        },
        {
            title: t("title"),
            dataIndex: 'bib_title',
            key: 'bib_title',
            render: (text, record) => {
                return <>
                <Row>
                    {/* <Col span={24}>
                    <Link to={'/library/backstage/AddItem/' + record?.bib_biblionumber} style={{ color: 'blue' }}>{text}{record?.bib_subtitle}</Link>{record?.bib_author}
                    </Col>
                    <Col span={24}>
                    <Link to={'/library/backstage/BookDetailItems/' + record?.item_itemnumber} style={{ color: 'blue' }}>{record?.item_barcode}</Link>
                    </Col> */}
                    <Col span={24}>{text}</Col>
                    <Col span={24}>{record?.bib_subtitle}</Col>
                    <Col span={24}>{record?.bib_author}</Col>
                    <Col span={24}>{record?.item_barcode}</Col>
                </Row>
                </>
            }
        },
        {
            title: t("category"),
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
        {
            title: t("collection"),
            dataIndex: 'collection',
            key: 'collection',
        },
        {
            title: t("location"),
            dataIndex: 'item_location',
            key: 'item_location',
        },
        {
            title: t("original_library"),
            dataIndex: 'item_branchname_home',
            key: 'item_branchname_home',
        },
        {
            title: t("borrow_date"),
            dataIndex: 'issue_issuedate',
            key: 'issue_issuedate',
        },
        {
            title: t("borrow_library"),
            dataIndex: 'issue_branchname',
            key: 'issue_branchname',
        },
        {
            title: t("fee"),
            dataIndex: 'issue_charge',
            key: 'issue_charge',
        },
        {
            title: t("fine"),
            dataIndex: 'issue_accountlines_amount',
            key: 'issue_accountlines_amount',
        },
        {
            title: t("price"),
            dataIndex: 'item_purchase_price',
            key: 'item_purchase_price',
        },
        {
            title: t("renew"),
            dataIndex: 'renew',
            key: 'renew',
            render: (_, record) => {
                return permission_level === 1 ? 
                <>
                    <Row gutter={[8, 8]}>
                        <Col>
                            {/* <Button variant="outline" onClick={() => CheckIn({ record })}>{t("return")}</Button> */}
                            <Button variant="outline" onClick={() => onReturnClick(record)}>{t("return")}</Button>
                        </Col>
                        <Col>
                            {/* <Button variant="outline" disabled={record?.issue_renewals_allow === record?.issue_renewals_count} onClick={() => Renew({ record })}>{t("checkout")}</Button> */}
                            {/* <Button variant="outline" onClick={() => handleEditRow(record)}>{t("renew")}</Button> */}
                            <Button variant="outline" onClick={() => postCheckoutRenewData([record])}>{t("renew")}</Button>
                        </Col>
                    </Row>
                    {extraActionRender(record)}
                </>
                : <></>
            }
        },
        ...customColumns,
    ];

    const setParamsFilter = (obj) => {
        return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
    }

    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleEditRow = (record) => {
        setAxiosMode("patch")
        setModalOpen(true)

        form.resetFields()
        form.setFieldsValue({
            issue_id: record?.issue_id
        })
    }
    const handleDeleteRow = (id) => {
        /* 刪除單／多筆資料 */
        let data = []
        /* 將PK做成陣列 */
        if (id) {
            /* 當單筆刪除時會帶入id */
            data = [{
                task_id: id
            }]
            /* 放入欲刪除的陣列 */
        }

        else {
            data = selectedRowsInfo.map((val) => {
                /* 將已勾選的資料遍歷 */
                return {
                    task_id: val?.task_id
                }
                /* 取出pk放回陣列 */
            })
        }
        if (data.length > 0) {
            /* 防呆未勾選任何資料 */
            Modal.confirm({
                /* 一次性使用Modal且有確定與取消的按鈕 */
                content: '確定要刪除嗎？',
                /* modal內容 */
                onOk: () => {
                    // deleteCheckoutHistoryData(data)
                    /* 當按下確定後觸發刪除資料 */
                },
                okText: '確定',
                /* 確定的按鈕顯示的文字 */
                cancelText: '取消',
                /* 取消的按鈕顯示的文字 */
                contentStyle: {
                    zindex: 99,
                }
            })
        }
        else {
            message.info("請選擇項目")
            /* 一次性呈現上方提示字 */
        }
    }

    const onFormFinish = (values) => {
        let body = {
            ...values,
            due_date: dayjs(values?.due_date).format("YYYY-MM-DD HH:mm:ss"),
        }
        if (axiosMode === "post") {
            postCheckoutRenewData([body])
            // postCheckoutSettingData([values])
        }
        else if (axiosMode === "patch") {
            postCheckoutRenewData([body])
            // patchCheckoutSettingData([values])
        }
    }


    const onCheckoutFinish = ({ axiosMode, status, values }) => {
        propsOnFinish({ axiosMode, status, values })
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reload();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            if (axiosMode !== "get") {
                setModalLoading(false)
                setModalOpen(false)
            }
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
            }
        }
    }
    const onCheckoutBefore = ({ axiosMode, status, values }) => {
        propsOnBefore({ axiosMode, status, values })
        // setModalLoading(true)
    }

    const onRenewFinish = ({ axiosMode, status, values }) => {
        propsOnFinish({ axiosMode, status, values })
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("續借成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reload();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            if (axiosMode !== "get") {
                setModalLoading(false)
                setModalOpen(false)
            }
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                if(values === "Renewal not authorized (too_many)") message.error("續借失敗，續借次數已達上限")
                else if(values === "Renewal not authorized (too_soon)") message.error("續借失敗，續借時間尚未開放")
                else if(values === "Renewal not authorized (on_reserve)") message.error("續借失敗，此本館藏已被人預約")
                else message.error("續借失敗")
                // Modal.confirm({
                //     width: 500,
                //     title: t('checkout'),
                //     content: <>此館藏已被借閱或是預約<br />請改為預約此館藏</>,
                //     onOk: () => {
                //         actionRef.current.reload();
                //         setSelectedRowKeys([])
                //         setSelectedRowsInfo([])
                //     },
                //     okText: t('ok'),
                //     cancelText: t('cancel'),
                // })
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
            }
            if (axiosMode !== "get") {
                setModalLoading(false)
                setModalOpen(false)
            }
        }
    }
    const onRenewBefore = ({ axiosMode, status, values }) => {
        propsOnBefore({ axiosMode, status, values })
        // setModalLoading(true)
    }

    const onBefore = (value) => {
        propsOnBefore({ value })
    }
    const onFinish = (value) => {
        propsOnFinish({ value })
        const axiosMode = value?.axiosMode
        const axiosStatus = value?.status
        switch (axiosMode) {
            case 'post':
                if (axiosStatus === 'success') toast.success('續借成功 !')
                else if (value?.message === "Renewal not authorized (too_many)") toast.error('續借失敗 ! 已達續借上限。')
                else if (value?.message === "Renewal not authorized (on_reserve)") toast.error('續借失敗 ! 預約中。')
                else toast.error('續借失敗 ! issue_id 並不存在')
                actionRef.current.reloadAndRest()
                break;
            default:
                break;
        }
    }
    const Renew = ({ record }) => {
        let RenewArray = (record ? [record] : selectedRowsInfo).map((row) => {
            return {
                "issue_id": row?.issue_id,  //row.issue_id
            }
        })
        postCheckoutRenewData(RenewArray)
    }
    // const CheckIn = ({ record }) => {
    //     let CheckInArray = (record ? [record] : selectedRowsInfo).map((row) => {
    //         return {
    //             "itemnumber": row?.item_itemnumber,  //row.issue_id
    //             "borrowernumber": row?.issue_borrowernumber,
    //             "branchcode": row?.issue_branchcode,
    //         }
    //     })
    //     postCheckinData(CheckInArray)
    // }
    const CheckIn = ({ record }) => {
        let CheckInArray = (record ? [record] : selectedRowsInfo).map((row) => {
            return {
                "itemnumber": row?.item_itemnumber,  //row.issue_id
                "borrowernumber": row?.issue_borrowernumber,
                // "branchcode": row?.issue_branchcode,
                "branchcode": row?.item_branchcode_home,
            }
        })
        postCheckinData(CheckInArray)
    }
    const onReturnClick = (record) => {
        setAxiosMode("post")
        Modal.confirm({
            width: 500,
            title: t('return'),
            content: <>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    // onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                label={t('return_branch')}
                                name={fieldName ? [fieldName, "return_branch"].join('.') : "return_branch"}
                                rules={!hasValue ? [ { required: true, message: "請輸入" } ] : []}
                            >
                                <Select
                                    style={{
                                        maxHeight: "80vh",
                                        minHeight: "20vh",
                                        overflowX: "scroll",
                                        overflowY: "scroll",
                                    }}
                                    options={LibraryData.map(item => (
                                        {
                                            label: item?.branchname,
                                            value: item?.branchcode,
                                        }
                                    ))}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </>,
            onOk: () => {
                const values = form.getFieldsValue()
                postCheckinData([
                    {
                        ...values,
                        branchcode: values?.return_branch, 
                        itemnumber: record?.item_itemnumber,
                        borrowernumber: record?.issue_borrowernumber
                    }
                ])
                form.resetFields()
            },
            onCancel: () => { form.resetFields() },
            okText: t('ok'),
            cancelText: t('cancel'),
        })
    }

    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectedRowsKeys)
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectedRowsInfo)
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value?.[propsRowKey])
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value?.[propsRowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record?.[propsRowKey])
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record?.[propsRowKey])
                selectRow = selectRow.filter(row => row?.[propsRowKey] !== record?.[propsRowKey])
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    
    const { check, setCheck, checkAll, setOrders, custom_filter_key } = useTableColumnsCheck(columns);

    const {
        getCheckoutHistoryData,
        postCheckoutRenewData
    } = propsUseCheckoutHistory({
        onBefore: onRenewBefore,
        onFinish: onRenewFinish
    })
    const {
        LibraryData,
        getLibraryData
    } = useLibrary({
        onBefore: () => { },
        onLibrary: () => { },
    })
    const {
        BorrowerData,
        getBorrowerData,
    } = useBorrower({
        onBefore: () => {
        },
        onFinish: () => {
        }
    })
    const {
        CheckoutData,
        getCheckoutData,
        postCheckoutData,
    } = propsUseCheckout({
        onBefore: onCheckoutBefore,
        onFinish: onCheckoutFinish,
    })
    const {
        getCheckinData,
        postCheckinData,
    } = useCheckin({
        onBefore: () => { },
        onFinish: (value) => {
            const axiosMode = value?.axiosMode
            const axiosStatus = value?.status
            switch (axiosMode) {
                case 'post':
                    if (axiosStatus === 'success') toast.success('還書成功 !')
                    else if (value?.message === "Renewal not authorized (too_many)") toast.error('還書失敗 !')
                    else if (value?.message === "Renewal not authorized (on_reserve)") toast.error('還書失敗 !')
                    else toast.error('還書失敗 !')
                    actionRef.current.reloadAndRest()
                    break;
                default:
                    break;
            }
        },
    })

    useEffect(() => {
        if (borrowernumber)
            getBorrowerData({
                borrowernumber: borrowernumber
            })
    }, [borrowernumber])

    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    useEffect(() => {
        getLibraryData()
    }, [])

    const borrower = BorrowerData?.find(_ => true)
    return <>
        <RenewSettingModal
            axiosMode={axiosMode}
            propsOpen={modalOpen}
            propsSetOpen={setModalOpen}
            propsForm={form}
            propsLoading={modalLoading}
            propsSetLoading={setModalLoading}
            onFinish={onFormFinish}
            customFormItems={customFormItems}
        />
        <ProTableOt
            actionRef={actionRef}
            columns={columns}
            check={check}
            setCheck={setCheck}
            headerTitle={<></>}
            rowKey={propsRowKey}
            request={async (params = {}, sort, filter) => {
                // setAxiosMode("get")
                let newParams = {
                };
                let order = setOrders(sort)
                newParams = {
                    // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                    ...newParams,
                    order,
                    size: params.pageSize,
                    cur_page: params.current,
                    custom_filter_value: params.keyword ?? "",
                    custom_filter_key: custom_filter_key,
                    // borrowernumber: borrowernumber,
                    // cardnumber: "001"
                    // "categorycode": "TEST",
                };
                newParams = setParamsFilter({
                    ...newParams,
                });
                // setPageSize(params?.pageSize ?? 20)
                return getCheckoutData({
                    ...newParams
                })
            }}
            extra_columns={extra_columns}
            set_extra_columns={set_extra_columns}
            manage_columns={true}
            rowSelection={{
                type: "checkbox",
                selectedRowKeys: selectedRowKeys,
                selectedRowsInfo: selectedRowsInfo,
                setSelectedRowKeys: setSelectedRowKeys,
                setSelectedRowsInfo: setSelectedRowsInfo,
                ...rowSelection,
                // onSelectAll: rowSelection?.onSelectAll,
                // onSelect: rowSelection?.onSelect,
                // onChange: rowSelection?.getCheckboxProps

            }}
            // modalOpen={modalOpen}
            // setModalOpen={setModalOpen}
            scroll={{
                x: "100vw"
            }}
            toolBarRender={() => toolBarRender([
                // <Button
                //     type={'primary'}
                //     onClick={() => handleAddRow()}
                // >
                //     {t('post_checkout')}
                // </Button>,
                // <Button
                //     variant={"batchDelete"}
                //     onClick={() => handleDeleteRow()}
                // >
                //     {t('delete_multiple')}
                // </Button>,
            ])}
            propsUseData={() => {
                return {
                    // postData: postCheckoutData,
                    // patchData: postCheckoutData,
                    // deleteData: deleteCheckoutHistoryData,
                }
            }}
            PropsPatchForm={
                <RenewSettingForm
                    // propsForm={form}
                    // propsShowKeys={propsShowKeys}
                    keyPrefix={keyPrefix}
                    customFormItems={customFormItems}
                />
            }
            propsPatchonFinish={({ axiosMode, status }) => {
                if (status === "success") {
                    actionRef.current.reload()
                } else {

                }
            }}
            propsPatchOnBefore={() => { }}
            // propsPatch
            // propsPost
            // propsDelete
            propsPatchProcess={(item) => {
                return ({
                    ...item,
                    issue_date_due: dayjs(item?.issue_date_due),
                })
            }}
            propsWidth={1000}
        />
        {/* <Row gutter={[8, 8]}>
            <Col>
                <Button onClick={CheckIn} variant='outline' disabled={selectedRowsInfo.length === 0}><Icon.Checkin />{t("return_selected_items")}</Button>
            </Col>
            <Col>
                <Button onClick={Renew} variant='outline' disabled={selectedRowsInfo.length === 0}><Icon.Renew />{t("renew_selected_items")}</Button>
            </Col>
            <Col hidden>
                <Button onClick={() => { Renew() }} variant='outline' ><Icon.RenewAll />{t("renew_all_items")}</Button>
            </Col>
        </Row> */}
    </>
}

export default RenewSettingProTableOt


const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([]);
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    };
    const setOrders = (sorter) => {
        let newOrders = Object.keys(sorter).map((key, index) => {
            if (sorter[key] === "descend") {
                return JSON.stringify({
                    column: key,
                    type: "DESC",
                });
            } else {
                return JSON.stringify({
                    column: key,
                    type: "ASC",
                });
            }
        });
        return newOrders;
    };
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders,
    };
};


const Icon = () => { }
Icon.Checkin = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="16"
            version="1.1"
            viewBox="0 0 384 448"
        >
            <g stroke="none" strokeOpacity="1" transform="translate(0 -604.362)">
                <path
                    fillOpacity="1"
                    strokeDasharray="none"
                    strokeMiterlimit="4"
                    strokeWidth="64"
                    d="M0 988.362h384v64H0z"
                ></path>
                <path
                    fillRule="evenodd"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeWidth="1"
                    d="M160 604.362v192l-96-96v80l128 128 128-128v-80l-96 96v-192h-64z"
                ></path>
            </g>
        </svg>
    );
}
Icon.Renew = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                fill="#000"
                fillRule="evenodd"
                d="M12 6c-3.31 0-6 2.69-6 6h3l-4 4-4-4h3c0-4.42 3.58-8 8-8 1.57 0 3.03.46 4.26 1.24L14.8 6.7A5.87 5.87 0 0012 6zm3 6l4-4 4 4h-3c0 4.42-3.58 8-8 8a7.93 7.93 0 01-4.26-1.24L9.2 17.3c.83.45 1.79.7 2.8.7 3.31 0 6-2.69 6-6h-3z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}
Icon.RenewAll = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
        >
            <g fill="#373737" strokeWidth="0.829" color="#000">
                <path
                    d="M8 11.141l-5.859-3.14 2.395-1.284-1.07-.574L0 8.001l8 4.286 8-4.286-3.465-1.858-1.068.574L13.861 8z"
                    style={{ InkscapeStroke: "none" }}
                ></path>
                <path
                    d="M8 14.854l-5.859-3.14 2.395-1.285-1.07-.573L0 11.714 8 16l8-4.286-3.465-1.858-1.068.573 2.394 1.285zM8 0L0 4.286l8 4.285 8-4.286zm0 1.146l5.86 3.14L8 7.426l-5.859-3.14z"
                    style={{ InkscapeStroke: "none" }}
                ></path>
            </g>
        </svg>
    );
}